import { marketMeta, marketMetaIt } from '~/search-domain/config/market-meta';
import { type BettingSplitsMarket } from '~/search-domain/pipelines/betting-splits/types';
import { type MatchupCentreMarket } from '~/search-domain/pipelines/match-centre/types';
import { type BettingInsightsElasticSearchContext } from '~/search-domain/types/contracts';

/**
 * Checks if a market is supported (has metadata) for the given country.
 * This is used to filter out unsupported markets like period-specific ones
 * (e.g., "1st Half Point Spread") while allowing known main markets.
 */

export function isMarketSupported(
  market: BettingSplitsMarket | MatchupCentreMarket,
  context: Pick<BettingInsightsElasticSearchContext, 'repubConfig' | 'repubCountry'>,
): boolean {
  const repubCountry = context.repubCountry;
  if (!repubCountry) return false;
  const marketName = market.marketDisplayNameMap[repubCountry] ?? market.marketDisplayNameMap.us;
  if (!marketName) return false;
  const marketLookup = repubCountry === 'it' ? marketMetaIt : marketMeta;
  return marketName in marketLookup;
}
